import api, { setHeaderToken, removeHeaderToken } from "../../../apis/Api";
import config from "../../../config";

import router from "@/router";
import { allMixin } from "@/mixins/allMixin.js";

export default {
  namespaced: true,
  state: {
    requestList: [],
    requestCount: {},
    monitoringList: [],
    monitoringCount: {},
    requestDetail: {},
    docSO: "",
    docWO: "",
    docCOC: "",
    docInvoice: "",
    ISP: [],
    image: '',
    meetMeRoom: [],
    customerRack: [],
    ISPRack: [],
    rackAvailableByLoc: [],
    rackspec: []
  },
  getters: {
    getRequestList(state) {
      return state.requestList;
    },
    getMonitoringList(state) {
      return state.monitoringList;
    },
    getMonitoringCount(state) {
      return state.monitoringCount;
    },
    getRequestCount(state) {
      return state.requestCount;
    },
    getRequestDetail(state) {
      return state.requestDetail;
    },
    getDocSO(state) {
      return state.docSO;
    },
    getDocWO(state) {
      return state.docWO;
    },
    getDocCOC(state) {
      return state.docCOC;
    },
    getDocInvoice(state) {
      return state.docInvoice;
    },
    getISP(state) {
      return state.ISP;
    },
    getMeetMeRoom(state) {
      return state.meetMeRoom;
    },
    getCustomerRack(state) {
      return state.customerRack;
    },
    getISPRack(state) {
      return state.ISPRack;
    },
    getRackAvailableByLoc(state) {
      return state.rackAvailableByLoc;
    },
    getrackspec(state) {
      return state.rackspec;
    },
    getImage(state) {
      return state.image;
    }
  },
  mutations: {
    setRequestList(state, payload) {
      state.requestList = payload;
    },
    setMonitoringList(state, payload) {
      state.monitoringList = payload;
    },
    setMonitoringCount(state, payload) {
      state.monitoringCount = payload;
    },
    setRequestCount(state, payload) {
      state.requestCount = payload;
    },
    setRequestDetail(state, payload) {
      state.requestDetail = payload;
    },
    setDocSO(state, payload) {
      state.docSO = payload;
    },
    setDocWO(state, payload) {
      state.docWO = payload;
    },
    setDocCOC(state, payload) {
      state.docCOC = payload;
    },
    setDocInvoice(state, payload) {
      state.docInvoice = payload;
    },
    setISP(state, payload) {
      state.ISP = payload;
    },
    setMeetMeRoom(state, payload) {
      state.meetMeRoom = payload;
    },
    setCustomerRack(state, payload) {
      state.customerRack = payload;
    },
    setISPRack(state, payload) {
      state.ISPRack = payload;
    },
    setRackAvailableByLoc(state, payload) {
      state.rackAvailableByLoc = payload;
    },
    setrackspec(state, payload) {
      state.rackspec = payload;
    },
    setImage(state, payload) {
      return state.image = payload;
    }
  },
  actions: {
    createRequest({ state, commit, dispatch, rootGetters }, payload) {
      dispatch("setLoading", true);
      let token = localStorage.getItem("token");
      return new Promise((resolve, reject) => {
        api({
          method: payload.method,
          url: payload.url,
          data: payload.data,
          withCredentials: true,
          headers: {
            Authorization: "Bearer " + token
          }
        })
          .then(res => {
            resolve(res);
            dispatch("setLoading", false);
          })
          .catch(err => {
            console.log("authjs=err" + err);
            reject(err);
            dispatch("setLoading", false);
            return false;
          });
      });
    },
    createRequestVisit({ state, commit, dispatch, rootGetters }, payload) {
      dispatch("setLoading", true);
      let token = localStorage.getItem("token");
      return new Promise((resolve, reject) => {
        api({
          method: payload.method,
          url: payload.url,
          data: payload.data,
          withCredentials: true,
          headers: {
            Authorization: "Bearer " + token
          }
        })
          .then(res => {
            resolve(res);
            dispatch("setLoading", false);
          })
          .catch(err => {
            console.log("authjs=err" + err);
            reject(err);
            dispatch("setLoading", false);
            return false;
          });
      });
    },
    getRequestList({ state, commit, dispatch, rootGetters }, payload) {
      dispatch("setLoading", true);
      let token = localStorage.getItem("token");
      api({
        method: "get",
        url: payload.url,
        params: payload.params,
        headers: {
          Authorization: "Bearer " + token
        }
      })
        .then(res => {
          if (res.respond.status == "success") {
            commit("setRequestList", res.respond.data);
          } else if (res.respond.status == "forbidden") {
            allMixin.methods.removeSession();
            router.push(`/login`).catch(() => { });
          }
          dispatch("setLoading", false);
        })
        .catch(err => {
          console.log("authjs=err" + err);
          dispatch("setLoading", false);
          return false;
        });
    },
    getMonitoringList({ state, commit, dispatch, rootGetters }, payload) {
      dispatch("setLoading", true);
      let token = localStorage.getItem("token");
      api({
        method: "get",
        url: payload.url,
        params: payload.params,
        headers: {
          Authorization: "Bearer " + token
        }
      })
        .then(res => {
          if (res.status == "Success") {
            commit("setMonitoringList", res.data);
          } else if (res.respond.status == "forbidden") {
            allMixin.methods.removeSession();
            router.push(`/login`).catch(() => { });
          }
          dispatch("setLoading", false);
        })
        .catch(err => {
          console.log("authjs=err" + err);
          dispatch("setLoading", false);
          return false;
        });
    },
    getRequestCount({ state, commit, dispatch, rootGetters }, payload) {
      dispatch("setLoading", true);
      let token = localStorage.getItem("token");
      api({
        method: "get",
        url: payload.url,
        headers: {
          Authorization: "Bearer " + token
        }
      })
        .then(res => {
          if (res.status == "Success") {
            commit("setRequestCount", res.data);
          } else if (res.respond.status == "forbidden") {
            allMixin.methods.removeSession();
            router.push(`/login`).catch(() => { });
          }
          dispatch("setLoading", false);
        })
        .catch(err => {
          console.log("authjs=err" + err);
          dispatch("setLoading", false);
          return false;
        });
    },
    getMonitoringCount({ state, commit, dispatch, rootGetters }, payload) {
      dispatch("setLoading", true);
      let token = localStorage.getItem("token");
      api({
        method: "get",
        url: payload.url,
        headers: {
          Authorization: "Bearer " + token
        }
      })
        .then(res => {
          if (res.status == "success") {
            let monitoringData = res.data;
            if (Array.isArray(monitoringData)) {
              monitoringData = monitoringData.slice().sort((a, b) => {
                if (a.type === 'Total') return -1;
                if (b.type === 'Total') return 1;
                return 0;
              });
            }

            commit("setMonitoringCount", monitoringData);
          } else if (res.respond.status == "forbidden") {
            allMixin.methods.removeSession();
            router.push(`/login`).catch(() => { });
          }
          dispatch("setLoading", false);
        })
        .catch(err => {
          console.log("authjs=err" + err);
          dispatch("setLoading", false);
          return false;
        });
    },
    getRequestDetail({ state, commit, dispatch, rootGetters }, payload) {
      dispatch("setLoading", true);
      let token = localStorage.getItem("token");
      return new Promise((resolve, reject) => {
        api({
          method: "post",
          url: payload.url,
          data: payload.data,
          headers: {
            Authorization: "Bearer " + token
          }
        })
          .then(res => {
            resolve(res);
            if (res.respond.status == "success") {
              commit("setRequestDetail", res.respond.data);
            } else if (res.respond.status == "forbidden") {
              allMixin.methods.removeSession();
              router.push(`/login`).catch(() => { });
            }
            dispatch("setLoading", false);
          })
          .catch(err => {
            reject(err);
            console.log("authjs=err" + err);
            dispatch("setLoading", false);
            return false;
          });
      });
    },
    getDocSO({ state, commit, dispatch, rootGetters }, payload) {
      dispatch("setLoading", true);
      let token = localStorage.getItem("token");
      api({
        method: "get",
        url: payload.url,
        params: payload.data,
        headers: {
          Authorization: "Bearer " + token
        }
      })
        .then(res => {
          if (res.respond.status == "success") {
            if (payload.data.document_type == "sales order") {
              commit("setDocSO", res.respond.data.doc_file);
            } else if (payload.data.document_type == "work order") {
              commit("setDocWO", res.respond.data.doc_file);
            } else if (payload.data.document_type == "coc") {
              commit("setDocCOC", res.respond.data.doc_file);
            } else if (payload.data.document_type == "invoices") {
              commit("setDocInvoice", res.respond.data.doc_file);
            }
          } else if (res.respond.status == "forbidden") {
            allMixin.methods.removeSession();
            router.push(`/login`).catch(() => { });
          }
          dispatch("setLoading", false);
        })
        .catch(err => {
          console.log("authjs=err" + err);
          dispatch("setLoading", false);
          return false;
        });
    },
    getResource({ state, commit, dispatch, rootGetters }, payload) {
      dispatch("setLoading", true);
      let token = localStorage.getItem("token");
      api({
        method: "get",
        url: payload.url,
        params: payload.params,
        headers: {
          Authorization: "Bearer " + token
        }
      })
        .then(res => {
          if (res.respond.status == "success") {
            if (payload.url == "isp/get") {
              commit("setISP", res.respond.data);
            } else if (payload.url == "isp/room") {
              commit("setMeetMeRoom", res.respond.data);
            } else if (payload.url == "customer/rack") {
              commit("setCustomerRack", res.respond.data);
            } else if (payload.url == "isp/rack") {
              commit("setISPRack", res.respond.data);
            } else if (payload.url == "rackspec/list") {
              commit("setrackspec", res.respond.data);
            }
          } else if (res.respond.status == "failed") {
            if (payload.url == "isp/get") {
              commit("setISP", []);
            } else if (payload.url == "isp/room") {
              commit("setMeetMeRoom", []);
            } else if (payload.url == "customer/rack") {
              commit("setCustomerRack", []);
            } else if (payload.url == "isp/rack") {
              commit("setISPRack", []);
            } else if (payload.url == "rackspec/list") {
              commit("setrackspec", []);
            }
          } else if (res.respond.status == "forbidden") {
            allMixin.methods.removeSession();
            router.push(`/login`).catch(() => { });
          }
          dispatch("setLoading", false);
        })
        .catch(err => {
          console.log("authjs=err" + err);
          dispatch("setLoading", false);
          return false;
        });
    },
    getRackByLoc({ state, commit, dispatch, rootGetters }, payload) {
      dispatch("setLoading", true);
      let token = localStorage.getItem("token");
      return new Promise((resolve, reject) => {
        api({
          method: "get",
          url: "rack/available",
          params: payload.params,
          headers: {
            Authorization: "Bearer " + token
          }
        })
          .then(res => {
            // resolve(res);
            console.log("payload.params", payload.params);
            let a = [];
            a[payload.params.dclocations] = res.respond.data;
            console.log("okkkkkkk", a);
            commit("setRackAvailableByLoc", a);
            dispatch("setLoading", false);
          })
          .catch(err => {
            reject(err);
            console.log("authjs=err" + err);
            dispatch("setLoading", false);
            return false;
          });
      });
    },
    uploadImage({ state, commit, dispatch, rootGetters }, payload) {
      dispatch("setLoading", true);
      let token = localStorage.getItem("token");

      return new Promise((resolve, reject) => {
        api({
          baseURL: config("api.baseUrl_storage"),
          method: "post",
          url: "upload/id/token",
          data: payload,
          withCredentials: true,
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "multipart/form-data"
          }
        })
          .then(res => {
            if (res.status === 'success') {
              resolve(res);
            } else {
              reject(new Error('Upload failed'));
            }
            dispatch("setLoading", false);
          })
          .catch(err => {
            console.log("authjs=err " + err);
            reject(err)
            dispatch("setLoading", false);
          });
      });
    },

    getPreviewImage({ state, commit, dispatch, rootGetters }, payload) {
      dispatch("setLoading", true);
      let token = localStorage.getItem("token");
      api({
        baseURL: config("api.baseUrl_storage"),
        method: "get",
        url: "/id/" + payload,
        responseType: "blob",
        headers: {
          Authorization: "Bearer " + token
        }
      })
        .then(response => {
          commit("setImage", URL.createObjectURL(response));
          dispatch("setLoading", false);
        })
        .catch(err => {
          console.log("authjs=err" + err);
          dispatch("setLoading", false);
          return false;
        });
    },

    setLoading({ commit }, payload) {
      commit("loader/setLoading", payload, {
        root: true
      });
    }
  }
};
